var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHacken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 36,
    viewBox: "0 0 299 36",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9753 0V12.1272H10.3986V0.00315189H0V35.5765H10.3986V23.0112H24.9753V35.5701H35.3746V0H24.9753Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.432 0V0.00315182H100.229V35.5765H110.746V35.5733H138.551V25.4717H110.746V10.1016H138.544V0H105.432Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.321 0V15.2956L272.81 0L272.781 0.0239555V0H262.363V35.5765H272.781V19.7759L287.321 35.5765H297.738V0H287.321Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.556 0V12.108H170.135V0.00630263H159.186V35.5739H170.135V22.9877H186.547V35.5765H197.497V22.6423H187.285L197.508 12.108V0H186.556Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1712 0.00315182V0H83.6573V0.00315182H85.4879V35.5733H75.1695V27.8716H60.4323V35.5765H50.1133V0.00315182H51.1712ZM75.1695 17.3615H60.4323V10.1016H75.1695V17.3615Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.133 0V0.00252083H212.248V35.5669H215.07V35.5765H247.558V25.4863H222.568V22.8344H247.563V12.7434H222.568V10.0909H247.623V0H215.133Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacken);
export default __webpack_public_path__ + "static/media/hacken.6b51a56b.svg";
export { ForwardRef as ReactComponent };